import React, { Fragment } from 'react';

import axios from 'axios';
import { PayPalButtons } from "@paypal/react-paypal-js";
import { buildCreditBoxRequestDto } from './globals';
import { UIButton, UIMessageBox } from '../components/guiElements';

export class SendaPayPalButton extends React.Component {

    constructor(props) {
        super(props);
        this.createOrder = this.createOrder.bind(this);
        this.onApprove = this.onApprove.bind(this);

    }

    createOrder() {

        if (!this.props.packetId || this.props.packetId.length == '')
            return;

        return axios('/api/cbPayment/paypal/createOrder', {
            method: 'post',
            data: buildCreditBoxRequestDto("PayPal", this.props.packetId),
            headers: {
                Authorization: 'Bearer ' + this.props.jwtToken
            }
        }).then(function (response) {
            if (response.data.result.data.success)
                return response.data.result.data.payload;
            else
                this.props.onError(response.data.result.data.errorMessage);
        }).then(function (payload) {
            return payload.orderId;
        }).catch(error => {
            if (this.props.onError)
                this.props.onError(error);
        });

    }
    onApprove(data) {
        var me = this;
        if (this.props.loaderShow)
            this.props.loaderShow();
        return axios('/api/cbPayment/paypal/approveOrder', {
            method: 'post',
            data: data,
            headers: {
                Authorization: 'Bearer ' + this.props.jwtToken
            }
        }).then(function (response) {
            if (response.data.result.data.success)
                return response.data.result.data;
            else
                me.props.onError(response.data.result.data.errorMessage);
           
        }).then(function (data) {
            if (me.props.loaderHide)
                me.props.loaderHide();
            if (me.props.onSuccess)
                me.props.onSuccess(data);
        }).catch(error => {
            if (me.props.loaderHide)
                me.props.loaderHide();
            if (me.props.onError)
                me.props.onError(error);
        });

    }
    render() {

       

        return (
            <PayPalButtons
                disabled={this.props.disabled ? this.props.disabled:false}
                style={{
                    
                    shape: "pill",
                    label: "pay",
                    tagline: false,
                    layout: "horizontal",
                }}
                createOrder={this.createOrder}
                onApprove={this.onApprove}
            />



        );


    }
    
}